import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Form, Input, Select } from "antd";
import axios from "axios";
import _, { debounce } from "lodash";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import { authenticateToken } from "../../utils/auth";
import { responseNotification } from "../../utils/notify";
import { regions } from "../common/Region";
const { Option } = Select;

const AddArea = ({ visibleData, onCloseMethod, inHub = false }: any) => {
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const route = useParams();

  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("JC_MART");
  const [addRegion, setAddRegion] = useState(false);
  const [areaData, setAreaData] = useState(undefined);
  const [regionsOptions, setRegionsOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [hubsOptions, setHubsOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const fetchRef = useRef(null);

  const onSubmit = async (data: any) => {
    setLoading(true);

    const readyData = data && {
      name: data.name,
      regionId: data.regionId,
      hubId: inHub ? (route as any).hubId : data.hubId,
    };

    if (!addRegion) {
      if (areaData) {
        await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/area`, {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...readyData,
            id: areaData?.id,
            isActive: true,
          }),
        })
          .then((res) => res.json())
          .then((res) => {
            setLoading(false);

            if (res.statusCode === 200) {
              responseNotification("Area Updated Successfully", "success");
              form.resetFields();
              if (onCloseMethod) {
                onCloseMethod();
              }
            } else if (res.status === 500) {
              responseNotification("Internal server error", "error");
            } else {
              responseNotification(res.message || "something wrong", "warning");
            }
          })
          .catch((err) => {
            setLoading(false);
            responseNotification(`${"Internal server error"} ${err}`, "error");
            console.error("err", err);
          });
      } else {
        await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/area`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(readyData),
        })
          .then((res) => res.json())
          .then((res) => {
            setLoading(false);

            if (res.statusCode === 200) {
              responseNotification("Area Created Successfully", "success");
              form.resetFields();
              if (onCloseMethod) {
                onCloseMethod();
              }
            } else if (res.status === 500) {
              responseNotification("Internal server error", "error");
            } else {
              responseNotification(res.message || "something wrong", "warning");
            }
          })
          .catch((err) => {
            setLoading(false);
            responseNotification(`${"Internal server error"} ${err}`, "error");
            console.error("err", err);
          });
      }
    } else {
      responseNotification(`Adding region operation is uncomplete`, "error");
    }
  };

  const getRegionsOptions = useCallback(
    async (val?: string) => {
      setRegionsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/region?` +
          (type ? `&type=${type}` : ``) +
          (val ? `&key=${val}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setRegionsOptions({
        loading: false,
        list: res?.data?.regions?.map((region: any) => {
          return {
            id: region?.id,
            name: region?.name,
          };
        }),
      });
    },
    [type]
  );

  const getHubsOptions = useCallback(async (key?: string) => {
    setHubsOptions({ loading: true, list: [] });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    const res = await axios.get(
      `${encodedUri}/hub/search?page=0&limit=20` + (key ? `&key=${key}` : ``),
      {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
        },
      }
    );

    setHubsOptions({
      loading: false,
      list: res?.data?.hub?.map((hub: any) => {
        return {
          id: hub?.id,
          name: hub?.name,
        };
      }),
    });
  }, []);

  const AddRegionSubmit = async (data: any) => {
    setLoading(true);

    await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/region`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authenticateToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: data.regionName,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);

        if (res.statusCode === 200) {
          responseNotification("Region Added Successfully", "success");
          form2.resetFields();
          getRegionsOptions();
          setAddRegion(false);
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (value) {
        if (field === "hub") getHubsOptions(value);
        else if (field === "region") getRegionsOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [getRegionsOptions, getHubsOptions]);

  useEffect(() => {
    getHubsOptions();
    getRegionsOptions();
  }, [getHubsOptions, getRegionsOptions]);

  useEffect(() => {
    if (visibleData) {
      setAreaData(visibleData);
    }
  }, [visibleData]);

  useEffect(() => {
    if (areaData) {
      form?.resetFields(Object.keys(visibleData));
    }
    form?.resetFields();
  }, [areaData]);

  return (
    <>
      <Form
        name="control-hooks"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        className="ant-form ant-form-vertical"
        onFinish={onSubmit}
        form={form} // like ref
        layout="vertical"
        // requiredMark="optional"
        autoComplete="off"
        initialValues={{
          regionId: areaData?.region?.id,
          hubId: areaData?.hub?.id,
          name: areaData?.name,
        }}
      >
        <div className="mb-3">
          {addRegion ? (
            <div>
              <Form
                name="control-hooks"
                onFinish={AddRegionSubmit}
                form={form2} // like ref
                layout="vertical"
                autoComplete="off"
                style={{
                  display: "block",
                  alignItems: "baseline",
                  position: "relative",
                }}
              >
                <Form.Item
                  label="Thana"
                  rules={[
                    {
                      required: true,
                      message: "Region is required!",
                    },
                  ]}
                  name="regionName"
                >
                  <Input
                    style={{ width: "calc(100% - 50px)" }}
                    placeholder="Enter Thana Name"
                  />
                </Form.Item>

                <div
                  className="d-flex"
                  style={{ position: "absolute", bottom: 0, right: 0 }}
                >
                  <Button
                    type="primary"
                    size="large"
                    htmlType="submit"
                    onClick={(e) => {
                      e.preventDefault();
                      form2.submit();
                    }}
                  >
                    Add
                  </Button>
                  <Button
                    type="dashed"
                    size="large"
                    danger
                    onClick={() => setAddRegion(!addRegion)}
                  >
                    <CloseOutlined />
                  </Button>
                </div>
              </Form>
            </div>
          ) : (
            <div
              style={{
                display: "block",
                alignItems: "baseline",
                position: "relative",
              }}
            >
              <div>
                <Form.Item
                  label={`Thana ${
                    areaData ? `(${areaData?.region?.name})` : ``
                  }`}
                  rules={[
                    {
                      required: true,
                      message: "Thana is required!",
                    },
                  ]}
                  name="regionId"
                  initialValue={areaData?.region?.id}
                >
                  <Select
                    showSearch
                    placeholder="Select Thana"
                    optionFilterProp="children"
                    // onChange={(val) => setRegionId(val)}
                    onSearch={(val) => {
                      handleSearch(val, "region");
                    }}
                    filterOption={(input, option) =>
                      option.children
                        .toString()
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    allowClear
                  >
                    {regionsOptions?.list?.map((region: any) => (
                      <Option value={region.id}>{region.name}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              <Button
                type="primary"
                danger
                size="large"
                onClick={() => setAddRegion(!addRegion)}
                style={{ position: "absolute", bottom: 0, right: 0 }}
              >
                <PlusOutlined />
              </Button>
            </div>
          )}
        </div>

        {/* <Form.Item name="status_search">
          <Select
            showSearch
            placeholder="Filter by Status"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children
                .toString()
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            <Select.Option value="">ALL STATUS</Select.Option>
            {Object.values(regions.Dhaka)?.map((region, i) => (
              <Select.Option value={type} key={i}>
                {region}
              </Select.Option>
            ))}
          </Select>
        </Form.Item> */}
        
        <Form.Item
          hasFeedback
          label="Area Name"
          rules={[
            {
              required: true,
              message: "Name is Required!",
            },
          ]}
          name="name"
        >
          <Input id="name" type="text" placeholder="Enter Area Name" />
        </Form.Item>

        {!inHub && (
          <Form.Item
            hasFeedback
            label={`Hub ${areaData ? `(${areaData?.hub?.name})` : ``}`}
            rules={[
              {
                required: true,
                message: "Hub is required!",
              },
            ]}
            name="hubId"
            initialValue={areaData?.hub?.id}
          >
            <Select
              showSearch
              placeholder="Select Hub"
              optionFilterProp="children"
              onSearch={(val) => {
                handleSearch(val, "hub");
              }}
              filterOption={(input, option) =>
                option.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              allowClear
            >
              {hubsOptions?.list?.map((hub: any) => (
                <Option value={hub.id}>{hub.name}</Option>
              ))}
            </Select>
          </Form.Item>
        )}

        <div className="buttons-container">
          <Button
            disabled={loading}
            loading={(loading ? "loading" : undefined) as any}
            type="primary"
            htmlType="submit"
            className="add-submit-btn text-center mr-2"
          >
            Submit
          </Button>
          <Button
            type="ghost"
            htmlType="button"
            onClick={() => form?.resetFields()}
            className="reset-submit-btn text-center mr-2"
          >
            Reset
          </Button>
        </div>
      </Form>
    </>
  );
};

export default AddArea;
